import { render, staticRenderFns } from "./ThePriceList.vue?vue&type=template&id=99de5218&"
import script from "./ThePriceList.vue?vue&type=script&lang=js&"
export * from "./ThePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports